import { Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { WrappedInsightsClient } from 'react-instantsearch-core'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useSegment } from '../../../../../hooks'
import { HitItem } from '../../types/hitItem'
import { getAlgoliaHitUrl } from '../../utils/getAlgoliaHitUrl'
import * as Styled from './styles'

interface AlgoliaHitItemProps {
  hit: HitItem
  insights: WrappedInsightsClient
}

export const AlgoliaHitItem = ({ hit, insights }: AlgoliaHitItemProps): ReactElement => {
  const { title, url, __queryID: queryId } = hit
  const { organization } = useUserOrganization()
  const { track } = useSegment()
  const linkUrl = getAlgoliaHitUrl({
    countryId: organization?.countryId,
    queryId,
    url,
  })

  const handleClick = useCallback(() => {
    insights('clickedObjectIDsAfterSearch', { eventName: 'Hit clicked' })
    // eslint-disable-next-line @typescript-eslint/naming-convention
    track('xxx-help-modal-article-search', { article_selected: true, article_link: linkUrl.split('?')[0] })
  }, [insights, linkUrl, track])

  return (
    <Styled.HitItemLink href={linkUrl} onClick={handleClick} rel="noopener noreferrer" target="_blank">
      <Styled.HitItemLeft>
        <Text weight="medium">{title}</Text>
      </Styled.HitItemLeft>
    </Styled.HitItemLink>
  )
}
